import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface Study {
  id: number;
  name: string;
}

export const useStudies = () => {
  const { data, isLoading } = useQuery<{ resources: Study[] }>({
    queryKey: ['dashboard', 'studies'],
    queryFn: () =>
      API.authenticated.fetch('/dashboard/studies').then(r => r.json()),
  });

  return { studies: data?.resources ?? [], isLoading };
};
